import syncApi from './syncApi';

const ROOT = '/auth/keycloak';

export const getKeycloakAdminConfig = () =>
  syncApi.get(`${ROOT}/config`).then((r) => r.data);

export const listKeycloakUsers = (search = '') =>
  syncApi.get(`${ROOT}/users`, { params: search ? { search } : {} }).then((r) => r.data);

export const createKeycloakUser = (payload) =>
  syncApi.post(`${ROOT}/users`, payload).then((r) => r.data);

export const updateKeycloakUser = (id, payload) =>
  syncApi.put(`${ROOT}/users/${encodeURIComponent(id)}`, payload).then((r) => r.data);

export const deleteKeycloakUser = (id) =>
  syncApi.delete(`${ROOT}/users/${encodeURIComponent(id)}`);

export const resetKeycloakPassword = (id, password, temporary = true) =>
  syncApi.put(`${ROOT}/users/${encodeURIComponent(id)}/password`, { password, temporary });

export const replaceKeycloakUserRoles = (id, roles) =>
  syncApi.put(`${ROOT}/users/${encodeURIComponent(id)}/roles`, { roles }).then((r) => r.data);

export const listKeycloakRoles = () =>
  syncApi.get(`${ROOT}/roles`).then((r) => r.data);

export const createKeycloakRole = (payload) =>
  syncApi.post(`${ROOT}/roles`, payload).then((r) => r.data);

export const updateKeycloakRole = (oldName, payload) =>
  syncApi.put(`${ROOT}/roles/${encodeURIComponent(oldName)}`, payload).then((r) => r.data);

export const deleteKeycloakRole = (name) =>
  syncApi.delete(`${ROOT}/roles/${encodeURIComponent(name)}`);

export const replaceKeycloakRoleModules = (roleName, modules) =>
  syncApi.put(`${ROOT}/roles/${encodeURIComponent(roleName)}/modules`, { modules }).then((r) => r.data);
